import styles from "../../assets/css/PatientUI/badge.module.css";

export const Badge = ({ text }) => <div className={styles.badge}>{text}</div>;
